(function () {

  window.slotMachine = {

    flagCompleted() {
      try {
        const key    = 'hs_slotmachine';
        const stored = JSON.parse(localStorage.getItem(key) || '{}');
        localStorage.setItem(key, JSON.stringify({ ...stored, ordered: true }));
      } catch(_) {}
    },

    addStylesheet(id, url) {
      if (document.getElementById(id)) return;
      var link = document.createElement('link');
      link.id   = id;
      link.rel  = 'stylesheet';
      link.type = 'text/css';
      link.href = url;
      document.head.appendChild(link);
    },

    init({ containerId, luckyProduct, prizesList, decoSymbolList, onEmailSubmit, labels = {}, doReset = false, waitForConsent = null, campaignStart = null }) {

      const ALL_SYMBOLS = [luckyProduct, ...prizesList];
      const SYMBOL_MAP  = Object.fromEntries(ALL_SYMBOLS.map(p => [p.key, p]));

      let activeState      = null;
      let activeOutcome    = null;
      let activePullNumber = 1;
      let claimed          = false;
      let isSpinning       = false;

      /* ── LocalStorage helpers ── */
      const STORAGE_KEY = 'hs_slotmachine';
      if (doReset) { try { localStorage.removeItem(STORAGE_KEY); } catch (_) {} }
      function readStorage() {
        try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {}; } catch (_) { return {}; }
      }
      function writeStorage(patch) {
        try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...readStorage(), ...patch })); } catch (_) {}
      }

      /* ── Trigger button (side tab) ── */
      function buildTriggerButton() {
        if (document.getElementById('hs-slot-trigger')) return;
        const btn = document.createElement('button');
        btn.id        = 'hs-slot-trigger';
        btn.className = 'hs-slot-trigger';
        btn.setAttribute('aria-label', labels.triggerAriaLabel || 'Lucky Wheel');
        btn.innerHTML = labels.triggerIcon || '🍒';
        btn.addEventListener('click', () => {
          writeStorage({ dismissed: false });
          slotMachineWidget.open({ source: 'manual' });
        });
        document.body.appendChild(btn);
      }

      function safeEvent(event) {
        try {
          if (slotMachineInterface && typeof slotMachineInterface.onEvent === 'function') {
            slotMachineInterface.onEvent(event);
          }
        } catch (_) {}
      }

      /* Maakt een symbool-div voor een echte prijs (eindpositie) */
      function createSymbol(symbolKey) {
        const product = SYMBOL_MAP[symbolKey] || luckyProduct;
        const div = document.createElement('div');
        div.className = 'hs-slot-symbol';
        const img = document.createElement('img');
        img.src = product.imageUrl;
        img.alt = product.title;
        div.appendChild(img);
        return div;
      }

      /* Maakt een symbool-div voor een decoratief icoon (alleen animatie) */
      function createDecoSymbol(deco) {
        const div = document.createElement('div');
        div.className = 'hs-slot-symbol';
        const img = document.createElement('img');
        img.src = deco.img;
        img.alt = deco.label;
        div.appendChild(img);
        return div;
      }

      function setReelToSymbol(reel, symbolKey) {
        const strip = reel.querySelector('.hs-slot-reel-strip');
        strip.innerHTML = '';
        strip.appendChild(createSymbol(symbolKey));
        strip.style.transition  = 'none';
        strip.style.transform   = 'translateY(0)';
      }

      /*
      * Bouwt de animatiestrip.
      * De "tussenliggende" frames mogen zowel echte producten als decoratieve
      * iconen bevatten. Het LAATSTE frame is altijd een echte prijs (finalSymbol).
      */
      function buildReelStrip(strip, finalSymbol, loops) {
        strip.innerHTML = '';
        const productKeys = ALL_SYMBOLS.map(p => p.key);

        for (let i = 0; i < loops; i++) {
          if (Math.random() < 0.38) {
            /* decoratief icoon — willekeurig, nooit als eindprijs */
            strip.appendChild(createDecoSymbol(decoSymbolList[Math.floor(Math.random() * decoSymbolList.length)]));
          } else {
            /* echt product symbool */
            strip.appendChild(createSymbol(productKeys[i % productKeys.length]));
          }
        }
        /* Eindpositie: altijd een echte prijs, nooit decoratief */
        strip.appendChild(createSymbol(finalSymbol));
      }

      function animateReel(reel, finalSymbol, index) {
        return new Promise((resolve) => {
          const strip       = reel.querySelector('.hs-slot-reel-strip');
          const symbolHeight = reel.clientHeight;
          const loops       = 16 + index * 6;

          buildReelStrip(strip, finalSymbol, loops);
          strip.style.transition = 'none';
          strip.style.transform  = 'translateY(0)';

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              strip.style.transition = `transform ${1.35 + index * 0.36}s cubic-bezier(.12,.72,.18,1)`;
              strip.style.transform  = `translateY(-${loops * symbolHeight}px)`;
            });
          });

          setTimeout(() => {
            setReelToSymbol(reel, finalSymbol);
            resolve();
          }, (1.5 + index * 0.4) * 1000);
        });
      }

      function makeConfetti(root) {
        const box = root.querySelector('[data-confetti]');
        if (!box) return;
        box.innerHTML = '';
        for (let i = 0; i < 34; i++) {
          const piece = document.createElement('i');
          piece.style.left             = Math.random() * 100 + '%';
          piece.style.animationDelay   = Math.random() * 0.25 + 's';
          piece.style.background       = ['#3c5410','#f5b942','#fc4797','#9db066','#7a5a35'][i % 5];
          box.appendChild(piece);
        }
        setTimeout(() => { box.innerHTML = ''; }, 1600);
      }

      function normalizeOutcome(outcome, pullNumber) {


        if (pullNumber === 1) {
          
          return {
            pullNumber: 1,
            reelSymbols: ['lucky7', 'lucky7', 'lucky7'],
            prizes: [{ type: luckyProduct.type, title: luckyProduct.title, imageUrl: luckyProduct.imageUrl, key: luckyProduct.key, productId: luckyProduct.productId, variantId: luckyProduct.variantId, discountCode: luckyProduct.discountCode }]
          };
        }

        const returnedKey  = outcome && outcome.reelSymbols && outcome.reelSymbols[0];
        const fallbackPrize = prizesList[Math.floor(Math.random() * prizesList.length)];
        const prize = SYMBOL_MAP[returnedKey] && returnedKey !== 'lucky7'
          ? SYMBOL_MAP[returnedKey]
          : fallbackPrize;
        console.log('[SlotMachine] Pull 2 prize resolved:', prize.key, '| discountCode:', prize.discountCode);

        return {
          pullNumber: 2,
          reelSymbols: [prize.key, prize.key, prize.key],
          prizes: [{ type: luckyProduct.type, title: prize.title, imageUrl: prize.imageUrl, key: prize.key, productId: prize.productId, variantId: prize.variantId, discountCode: prize.discountCode }]
        };
      }

      function renderPrizePreview(root) {
        root.querySelectorAll('[data-prize-preview], [data-prize-preview-email]').forEach(preview => {
          preview.innerHTML = '';
          prizesList.forEach((product) => {
            const item = document.createElement('div');
            item.className = 'hs-slot-preview-item';
            item.innerHTML = `<img src="${product.imageUrl}" alt="${product.title}"><span>${product.title}</span>`;
            preview.appendChild(item);
          });
        });
      }

      function renderPrize(root, outcome) {
        const prize = outcome.prizes[0];
        const card  = root.querySelector('[data-prize-card]');
        const text  = activePullNumber === 1
          ? (labels.prizePull1Subtitle || '')
          : (labels.prizePull2Subtitle || '');

        const badge = activePullNumber === 2 && labels.prizePull2Badge
          ? `<div class="hs-slot-prize-badge">${labels.prizePull2Badge}</div>`
          : '';

        card.innerHTML = `
          ${badge}
          <img src="${prize.imageUrl}" alt="${prize.title}">
          <strong>${prize.title}</strong>
          <span style="color:#3F6B2C;font-weight:700;">${text}</span>
        `;
      }

      function updateSpinContent(root) {
        const badge          = root.querySelector('[data-badge]');
        const title          = root.querySelector('[data-spin-title]');
        const subtitle       = root.querySelector('[data-spin-subtitle]');
        const helper         = root.querySelector('[data-helper]');
        const button         = root.querySelector('[data-spin]');
        const bubbleContent  = root.querySelector('[data-info-bubble-content]');

        if (button) button.disabled = false;

        if (activePullNumber === 1) {
          badge.textContent    = labels.spin1Badge    || '';
          title.textContent    = labels.spin1Title    || '';
          subtitle.textContent = labels.spin1Subtitle || '';
          helper.textContent   = '';
          helper.hidden        = true;
          button.textContent   = labels.spin1Button   || '';
          if (bubbleContent) bubbleContent.innerHTML = labels.spin1Info || '';
          root.querySelectorAll('.hs-slot-reel').forEach(reel => setReelToSymbol(reel, 'lucky7'));
        } else {
          badge.textContent    = labels.spin2Badge    || '';
          title.textContent    = labels.spin2Title    || '';
          subtitle.textContent = labels.spin2Subtitle || '';
          helper.textContent   = '';
          helper.hidden        = true;
          button.textContent   = labels.spin2Button   || '';
          if (bubbleContent) bubbleContent.innerHTML = labels.spin2Info || '';
          root.querySelectorAll('.hs-slot-reel').forEach((reel, i) => setReelToSymbol(reel, prizesList[i % prizesList.length].key));
        }
      }

      function buildMarkup(container, alreadyPlayed = false) {
        const L = labels;
        container.innerHTML = `
          <div class="hs-slot-root${alreadyPlayed ? ' show-already-played' : ''}" role="dialog" aria-modal="true" aria-label="${L.machineAriaLabel || 'Lucky Wheel'}">
            <div class="hs-slot-overlay"></div>
            <div class="hs-slot-card">
              <div class="hs-slot-confetti" data-confetti></div>
              <button class="hs-slot-close" type="button" aria-label="${L.closeAriaLabel || 'Sluiten'}" data-close>×</button>

              <!-- Info bubble (floats over card content) -->
              <div class="hs-slot-info-bubble" data-info-bubble hidden>
                <button class="hs-slot-info-bubble-close" type="button" data-info-bubble-close aria-label="${L.closeAriaLabel || 'Sluiten'}">×</button>
                <div class="hs-slot-info-bubble-content" data-info-bubble-content></div>
              </div>

              <div class="hs-slot-inner">

                <!-- View: draai -->
                <div class="hs-slot-view-spin">
                  <div class="hs-slot-brand">
                    <img src="https://cdn.shopify.com/s/files/1/0561/0120/8138/files/Good_vibes._Great_care._1.png?v=1759828772" alt="HappySoaps" class="hs-slot-brand-logo">
                  </div>
                  <h2 class="hs-slot-title" data-spin-title></h2>
                  <p class="hs-slot-subtitle" data-spin-subtitle></p>
                  <div class="hs-slot-badge-wrap"><div class="hs-slot-badge" data-badge></div></div>
                  <span class="hs-slot-info-trigger" data-info-trigger><span class="hs-slot-info-trigger-icon" aria-hidden="true">ⓘ</span><span class="hs-slot-info-trigger-text">${L.infoTrigger || 'Lees hoe het werkt'}</span></span>

                  <div class="hs-slot-machine-wrap">
                    <div class="hs-slot-machine">
                      <div class="hs-slot-reel-window">
                        <div class="hs-slot-reel"><div class="hs-slot-reel-strip"></div></div>
                        <div class="hs-slot-reel"><div class="hs-slot-reel-strip"></div></div>
                        <div class="hs-slot-reel"><div class="hs-slot-reel-strip"></div></div>
                      </div>
                    </div>
                    <div class="hs-slot-lever" aria-hidden="true"><div class="hs-slot-lever-knob"></div></div>
                  </div>

                  <div class="hs-slot-prize-preview-wrap">
                    <strong>${L.spin1PreviewLabel || ''}</strong>
                    <div class="hs-slot-prize-preview" data-prize-preview></div>
                  </div>

                  <div class="hs-slot-helper" data-helper></div>
                  <button class="hs-slot-primary" type="button" data-spin></button>
                </div>

                <!-- View: prijs gewonnen -->
                <div class="hs-slot-view-prize">
                  <div class="hs-slot-brand">
                    <img src="https://cdn.shopify.com/s/files/1/0561/0120/8138/files/Good_vibes._Great_care._1.png?v=1759828772" alt="HappySoaps" class="hs-slot-brand-logo">
                  </div>
                  <h2 class="hs-slot-title">${L.prizeTitle || ''}</h2>
                  <p class="hs-slot-subtitle" data-prize-subtitle></p>
                  <div class="hs-slot-prize-card" data-prize-card></div>
                  <button class="hs-slot-primary" type="button" data-claim>${L.claimButton || ''}</button>
                </div>

                <!-- View: email voor spin 2 -->
                <div class="hs-slot-view-email">
                  <div class="hs-slot-brand">
                    <img src="https://cdn.shopify.com/s/files/1/0561/0120/8138/files/Good_vibes._Great_care._1.png?v=1759828772" alt="HappySoaps" class="hs-slot-brand-logo">
                  </div>
                  <h2 class="hs-slot-title">${L.emailTitle || ''}</h2>
                  <p class="hs-slot-subtitle">${L.emailSubtitle || ''}</p>
                  <div class="hs-slot-email-box">
                    <strong>${L.emailBoxLabel || ''}</strong>
                    <input type="email" data-email-input placeholder="${L.emailPlaceholder || ''}" aria-label="${L.emailAriaLabel || ''}">
                  </div>
                  <div class="hs-slot-prize-preview-wrap">
                    <strong>${L.emailPrizeLabel || ''}</strong>
                    <div class="hs-slot-prize-preview" data-prize-preview-email></div>
                  </div>
                  <button class="hs-slot-primary" type="button" data-email-submit>${L.emailSubmitButton || ''}</button>
                  <button class="hs-slot-secondary" type="button" data-skip-email>${L.emailSkipButton || ''}</button>
                </div>

                <!-- View: succes -->
                <div class="hs-slot-view-success">
                  <div class="hs-slot-success-icon">✓</div>
                  <h2 class="hs-slot-title">${L.successTitle || ''}</h2>
                  <p class="hs-slot-subtitle">${L.successSubtitle || ''}</p>
                  <button class="hs-slot-primary" type="button" data-finish>${L.finishButton || ''}</button>
                </div>

                <!-- View: al meegespeeld -->
                <div class="hs-slot-view-already-played">
                  <div class="hs-slot-brand">
                    <img src="https://cdn.shopify.com/s/files/1/0561/0120/8138/files/Good_vibes._Great_care._1.png?v=1759828772" alt="HappySoaps" class="hs-slot-brand-logo">
                  </div>
                  <div class="hs-slot-success-icon">🍒</div>
                  <h2 class="hs-slot-title">${L.alreadyPlayedTitle || ''}</h2>
                  <p class="hs-slot-subtitle">${L.alreadyPlayedText || ''}</p>
                  <button class="hs-slot-primary" type="button" data-finish>${L.alreadyPlayedButton || ''}</button>
                </div>

              </div>
            </div>
          </div>
        `;

        const root = container.querySelector('.hs-slot-root');
        if (!alreadyPlayed) {
          renderPrizePreview(root);
          updateSpinContent(root);
        }
        bindEvents(root);
      }

      async function handleSpin(root) {
        if (isSpinning) return;
        isSpinning   = true;
        claimed      = false;
        activeOutcome = null;

        const spinButton = root.querySelector('[data-spin]');
        const helper     = root.querySelector('[data-helper]');
        const reels      = Array.from(root.querySelectorAll('.hs-slot-reel'));

        spinButton.disabled    = true;
        helper.textContent     = labels.spinningHelper || '';
        helper.hidden          = false;
        root.classList.add('is-spinning');
        safeEvent({ type: 'lever_pulled', pullNumber: activePullNumber });

        try {
          let resolvedOutcome = null;
          if (slotMachineInterface && typeof slotMachineInterface.resolveSpin === 'function') {
            resolvedOutcome = await slotMachineInterface.resolveSpin(activePullNumber);
          }

          activeOutcome = normalizeOutcome(resolvedOutcome, activePullNumber);
         
          safeEvent({ type: 'animation_started', pullNumber: activePullNumber, outcome: activeOutcome });

          /* Fire cart add and animation in parallel — cart is claimed the moment the prize is won */
          const [,] = await Promise.all([
            Promise.all(reels.map((reel, i) => animateReel(reel, activeOutcome.reelSymbols[i], i))),
            slotMachineInterface.onWinClaimed(activePullNumber, activeOutcome).catch(() => {})
          ]);

          claimed = true;
          root.classList.remove('is-spinning');
          helper.textContent = labels.spinWinHelper || '';
          makeConfetti(root);
          safeEvent({ type: 'animation_complete', outcome: activeOutcome });

          setTimeout(() => {
            renderPrize(root, activeOutcome);
            root.classList.add('show-prize');
            safeEvent({ type: 'prize_displayed', outcome: activeOutcome });
          }, 500);
        } catch (err) {
          root.classList.remove('is-spinning');
          helper.textContent  = labels.spinErrorHelper || '';
          spinButton.disabled = false;
        } finally {
          isSpinning = false;
        }
      }

      function handleClaim(root) {
        if (!activeOutcome) return;

        safeEvent({ type: 'prize_claimed', outcome: activeOutcome });

        if (activePullNumber === 1) {
          root.classList.remove('show-prize');
          root.classList.add('show-email');
          activePullNumber = 2;
          updateSpinContent(root);
          return;
        }

        root.classList.remove('show-prize');
        root.classList.add('show-success');
        makeConfetti(root);
      }

      function handleEmailSubmit(root) {
        const input = root.querySelector('[data-email-input]');
        const email = input ? input.value.trim() : '';

        if (!email || !email.includes('@')) {
          input.focus();
          input.style.borderColor = '#fc4797';
          return;
        }

        safeEvent({ type: 'email_submitted_for_second_spin', email });

        /* Email handler — fire and forget, never blocks the UI */
        if (typeof onEmailSubmit === 'function') {
          Promise.resolve(onEmailSubmit(email)).catch(() => {});
        }

        writeStorage({ status: 'pull2_ready' });
        root.classList.remove('show-email', 'show-prize', 'show-success');
        activePullNumber = 2;
        claimed          = false;
        isSpinning       = false;
        activeOutcome    = null;
        updateSpinContent(root);
      }

      function closeViaInterface() {
        try {
          if (slotMachineInterface && typeof slotMachineInterface.onClose === 'function') {
            slotMachineInterface.onClose();
            return;
          }
        } catch (_) {}
        const root = document.querySelector('.hs-slot-root');
        if (root) root.remove();
      }

      function bindEvents(root) {
        root.querySelector('[data-spin]').addEventListener('click',         () => handleSpin(root));
        root.querySelector('.hs-slot-lever').addEventListener('click', () => handleSpin(root));
        root.querySelector('[data-claim]').addEventListener('click',        () => handleClaim(root));
        root.querySelector('[data-email-submit]').addEventListener('click', () => handleEmailSubmit(root));
        root.querySelector('[data-email-input]').addEventListener('keydown', (e) => { if (e.key === 'Enter') handleEmailSubmit(root); });
        root.querySelector('[data-skip-email]').addEventListener('click',   closeViaInterface);
        root.querySelector('[data-finish]').addEventListener('click',       closeViaInterface);
        root.querySelector('[data-close]').addEventListener('click',        closeViaInterface);

        /* Info bubble */
        const infoBubble   = root.querySelector('[data-info-bubble]');
        const infoTrigger  = root.querySelector('[data-info-trigger]');
        if (infoBubble && infoTrigger) {
          infoTrigger.addEventListener('click', (e) => {
            e.stopPropagation();
            const opening = infoBubble.hidden;
            infoBubble.hidden = !opening;
            if (opening) {
              const card        = root.querySelector('.hs-slot-card');
              const triggerRect = infoTrigger.getBoundingClientRect();
              const cardRect    = card.getBoundingClientRect();
              const topOffset   = triggerRect.bottom - cardRect.top + card.scrollTop + 8;
              infoBubble.style.top = topOffset + 'px';
            }
          });
          infoBubble.querySelector('[data-info-bubble-close]').addEventListener('click', () => {
            infoBubble.hidden = true;
          });
          /* Stop clicks inside the bubble from closing it */
          infoBubble.addEventListener('click', (e) => e.stopPropagation());
          /* Close on click anywhere outside the bubble */
          root.addEventListener('click', () => { infoBubble.hidden = true; });
        }
      }

      const slotMachineWidget = {
        init({ containerId }) {
          /* Order placed on this device during the campaign — hide entirely */
          try {
            const lastOrder = localStorage.getItem('hs_slotmachine_last_order');
            if (lastOrder && campaignStart && new Date(lastOrder) > new Date(campaignStart)) return;
          } catch(_) {}

          const container = document.getElementById(containerId);
          if (!container) return;

          const stored = readStorage();

          /* Already interacted before — show trigger, consent already given */
          if (stored.dismissed || stored.status === 'completed') {
            buildTriggerButton();
            return;
          }

          /* First visit — wait for cookie consent before auto-opening */
          const consentGiven = () => typeof waitForConsent === 'function' ? waitForConsent() : true;

          if (consentGiven()) {
            this.open({ source: 'auto' });
          } else {
            const poll = setInterval(() => {
              if (consentGiven()) {
                clearInterval(poll);
                this.open({ source: 'auto' });
              }
            }, 400);
          }
        },

        open({ source = 'auto' } = {}) {
          const container = document.getElementById(containerId);
          if (!container) return;

          const stored      = readStorage();
          const alreadyPlayed = stored.status === 'completed';

          /* Reset state variables */
          activeOutcome    = null;
          claimed          = false;
          isSpinning       = false;

          /* Determine which pull to restore */
          const showEmailView = !alreadyPlayed && stored.status === 'pull1_done';
          activePullNumber    = (!alreadyPlayed && (stored.status === 'pull1_done' || stored.status === 'pull2_ready')) ? 2 : 1;

          buildMarkup(container, alreadyPlayed);

          /* Restore email view if player closed mid-flow */
          if (showEmailView) {
            const root = container.querySelector('.hs-slot-root');
            if (root) root.classList.add('show-email');
          }
        }
      };


      const slotMachineInterface = {

        getState() {
          return { eligible: true };
        },

        async resolveSpin(pullNumber) {
          if (pullNumber === 1) {
            return { pullNumber: 1, reelSymbols: ['lucky7', 'lucky7', 'lucky7'], prizes: [] };
          }
          const activeKeys = prizesList.map(p => p.key);
          const key = activeKeys[Math.floor(Math.random() * activeKeys.length)];
          return { pullNumber: 2, reelSymbols: [key, key, key], prizes: [] };
        },

        async onWinClaimed(pullNumber, outcome) {
          const prize = outcome.prizes[0];
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: prize.variantId, quantity: 1 }] })
          });
          if (!response.ok) {
            const err = await response.json().catch(() => ({}));
            throw new Error(err.description || labels.cartError || 'Cart error');
          }

          /* Apply discount code if defined on the product */
          if (prize.discountCode) {
            console.log('[SlotMachine] Applying discount code:', prize.discountCode);
            const discountRes = await fetch(`/discount/${encodeURIComponent(prize.discountCode)}`).catch(e => { console.error('[SlotMachine] Discount fetch error:', e); });
            console.log('[SlotMachine] Discount response:', discountRes?.status, discountRes?.url);
          } else {
            console.warn('[SlotMachine] No discountCode on prize:', prize);
          }

          document.dispatchEvent(new CustomEvent('cart:refresh'));
          writeStorage({ status: pullNumber === 1 ? 'pull1_done' : 'completed' });
        },

        onClose() {
          const root = document.querySelector('.hs-slot-root');
          if (root) root.remove();
          writeStorage({ dismissed: true });
          buildTriggerButton();
        }

      };

      slotMachineWidget.init({ containerId });
      
    }
  }


})();